import { z } from "zod";

import { I18nKeyType } from "@libs/i18n";
import {
  publicLessonRouteLevelEnumSchema,
  rowLessonRoutesTypeSchema,
} from "@libs/schemas";

export const lessonRouteSchema = rowLessonRoutesTypeSchema;
export type LessonRouteType = z.infer<typeof lessonRouteSchema>;

export const lessonRouteOptionSchema = lessonRouteSchema.pick({
  id: true,
  name: true,
  level: true,
  campus_id: true,
});
export type LessonRouteOptionType = z.infer<typeof lessonRouteOptionSchema>;

export type LessonRouteLevelType = z.infer<
  typeof publicLessonRouteLevelEnumSchema
>;

export const LESSON_ROUTE_LEVELS = publicLessonRouteLevelEnumSchema.options;

export const LESSON_ROUTE_LEVEL_I18N_KEYS: Record<
  LessonRouteLevelType,
  I18nKeyType
> = {
  BEGINNER: "main:events.route.levels.beginner",
  INTERMEDIATE: "main:events.route.levels.intermediate",
  ADVANCED: "main:events.route.levels.advanced",
  EXPRESSWAY: "main:events.route.levels.expressway",
};
